import React from 'react';
import logoRockstar from '../assets/images/logo_rockstars.png';
import arrowtop from '../assets/images/arrowtop.png';
import facebook from '../assets/images/facebook.png';
import instagram from '../assets/images/instagram.png';





function Footer() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <button onClick={handleScrollToTop} className="scroll-to-top">
          <span>VOLVER</span>
          <div className="arrow-up">
            {/* Aquí puedes cargar tu imagen o ícono de flecha */}
            <img src={arrowtop} alt='Arrow top'></img>
          </div>
          <span>ARRIBA</span>
        </button>
      </div>
      <div className="footer-bottom">
        <div className="footer-logo">
          {/* Aquí puedes agregar tu logo */}
          <img src={logoRockstar} alt='Logo rockstar'></img>
        </div>
        <div className="footer-line"></div>
        <div className="footer-social">
          {/* Aquí puedes agregar íconos o imágenes para Facebook e Instagram */}
          <img src={facebook} alt='Logo facebook'></img>
          <img src={instagram} alt='Logo instagram'></img>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
